import React, { SyntheticEvent, Fragment } from 'react'
import {
  Modal,
  Form,
  Divider,
  InputProps,
  Header,
  Dimmer,
  Loader,
  Segment,
  Input,
  Card,
  Label,
  Icon,
  Button
} from 'semantic-ui-react'

import { IVoucher, customerStore } from '../model/customer.model'
import Bluebird from 'bluebird'
import { handleErrorResponse } from '../libs/error-handler'
import { format } from 'date-fns'

interface IModalEditVoucherProps {
  onSelectVoucher: Function
}

interface IModalEditVoucherState {
  openModal: boolean
  clickedSearch: boolean
  loadingVoucher: boolean
  couponCode: string
  voucher: IVoucher | null
}

export class ModalSelectVoucher extends React.Component<
  IModalEditVoucherProps,
  IModalEditVoucherState
> {
  constructor(props: any) {
    super(props)
    this.state = this.initialState
  }

  initialState: IModalEditVoucherState = {
    openModal: false,
    couponCode: '',
    clickedSearch: false,
    voucher: null,
    loadingVoucher: false
  }

  searchInput: Input | null = null
  nameInput: Input | null = null

  handleInputRef = (input: Input) => {
    this.searchInput = input
  }

  resetState = () => {
    this.setState(this.initialState)
  }

  handleCouponCodeChange = (e: SyntheticEvent, { value }: InputProps) => {
    this.setState({ couponCode: value })
  }

  selectVoucher = (voucher: IVoucher) => {
    this.props.onSelectVoucher(voucher)
    this.resetState()
  }

  updateOrderPromise?: Bluebird<any>

  searchingVoucherPromise?: Bluebird<any>
  handleSearchVoucher = async () => {
    this.setState({
      loadingVoucher: true,
      clickedSearch: true
    })
    try {
      this.searchingVoucherPromise = customerStore.searchVoucher(this.state.couponCode)
      const voucher = await this.searchingVoucherPromise

      this.setState({ voucher })
      // Don't auto-close modal, let user review voucher info
      // User can click on voucher card or a button to select it
      // this.selectVoucher(voucher)
      // this.handleCloseModal()
    } catch (e) {
      handleErrorResponse(e)
    } finally {
      if (!this.searchingVoucherPromise!.isCancelled()) {
        this.setState({ loadingVoucher: false })
      }
    }
  }

  handleSelectAndClose = () => {
    if (this.state.voucher) {
      this.selectVoucher(this.state.voucher)
      this.handleCloseModal()
    }
  }

  componentWillUnmount() {
    if (this.searchingVoucherPromise) this.searchingVoucherPromise.cancel()
    if (this.updateOrderPromise) this.updateOrderPromise.cancel()
  }

  handleOpenModal = () => {
    this.setState({ openModal: true })
    setTimeout(() => {
      if (this.searchInput) {
        this.searchInput.focus()
      }
    })
  }

  handleCloseModal = () => {
    this.setState({ openModal: false })
  }

  render() {
    return (
      <Modal
        trigger={this.props.children}
        open={this.state.openModal}
        onOpen={this.handleOpenModal}
        onClose={this.handleCloseModal}
      >
        <Modal.Header>Tìm Voucher</Modal.Header>
        <Modal.Content>
          <Divider />

          <Fragment>
            <Form>
              <Form.Field>
                <Input
                  type="tel"
                  value={this.state.couponCode}
                  onChange={this.handleCouponCodeChange}
                  ref={this.handleInputRef}
                  action={{
                    color: 'teal',
                    labelPosition: 'right',
                    icon: 'search',
                    content: 'Tìm kiếm',
                    onClick: this.handleSearchVoucher,
                    disabled: this.state.loadingVoucher
                  }}
                  placeholder="Nhập mã voucher"
                />
              </Form.Field>
            </Form>
            <Segment basic vertical>
              <Dimmer inverted active={this.state.loadingVoucher}>
                <Loader />
              </Dimmer>
              {this.state.voucher && this.state.clickedSearch && (
                <Card fluid>
                  <Card.Content>
                    <Card.Header>{this.state.voucher.name}</Card.Header>
                    <Card.Meta>
                      <span className="date">Mã: {this.state.voucher.couponCode || 'N/A'}</span>
                    </Card.Meta>
                    <Card.Description>
                      <div style={{ marginTop: '10px' }}>
                        {this.state.voucher.amount ? (
                          <Label basic>
                            <Icon name="money" />
                            Giá trị: {this.state.voucher.amount.toLocaleString('vi-VN')}đ
                          </Label>
                        ) : null}
                        {/* Để ko bị lỗi hiện mỗi số 0 */}
                        {this.state.voucher.minValueOrder ? (
                          <Label basic>
                            <Icon name="cart" />
                            Đơn tối thiểu:{' '}
                            {this.state.voucher.minValueOrder.toLocaleString('vi-VN')}đ
                          </Label>
                        ) : null}
                      </div>
                      {/* date */}
                      <div style={{ marginTop: '10px' }}>
                        {this.state.voucher.startDate && (
                          <Label basic color="green">
                            <Icon name="calendar check" />
                            Bắt đầu: {format(new Date(this.state.voucher.startDate), 'DD/MM/YYYY')}
                          </Label>
                        )}
                        {this.state.voucher.expiryDate && (
                          <Label basic color="orange">
                            <Icon name="calendar times" />
                            Hết hạn: {format(new Date(this.state.voucher.expiryDate), 'DD/MM/YYYY')}
                          </Label>
                        )}
                      </div>
                      {/* outlet */}
                      {this.state.voucher.outlets && this.state.voucher.outlets.length > 0 ? (
                        <div style={{ marginTop: '10px' }}>
                          <Label basic color="purple">
                            <Icon name="building" />
                            Chi nhánh áp dụng:{' '}
                            {this.state.voucher.outlets
                              .map(outlet => {
                                if (typeof outlet === 'string') {
                                  return outlet
                                } else if (outlet && typeof outlet === 'object') {
                                  return outlet.code || outlet.name || outlet._id
                                }
                                return ''
                              })
                              .filter(Boolean)
                              .join(', ')}
                          </Label>
                        </div>
                      ) : null}
                    </Card.Description>
                  </Card.Content>
                  <Card.Content extra>
                    <Button
                      primary
                      fluid
                      onClick={this.handleSelectAndClose}
                      disabled={
                        (this.state.voucher.expiryDate &&
                          new Date(this.state.voucher.expiryDate) < new Date()) ||
                        (this.state.voucher.startDate &&
                          new Date(this.state.voucher.startDate) > new Date())
                      }
                    >
                      <Icon name="check" />
                      Chọn voucher này
                    </Button>
                  </Card.Content>
                </Card>
              )}
              {!this.state.voucher && this.state.clickedSearch && (
                <Header>Không tìm thấy voucher!</Header>
              )}
            </Segment>
          </Fragment>
        </Modal.Content>
      </Modal>
    )
  }
}
